import {Component, OnInit} from '@angular/core';
import {paths} from '~/app/app-paths';
import {Router} from '@angular/router';
import {ItemGlSetupService} from '~/app/core/services/item-gl-setup.service';
import {ItemGLSetupDetail} from '@model/ItemGLSetupDetail';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-item-gl-details',
  templateUrl: './item-gl-details.component.html',
  styleUrls: ['./item-gl-details.component.scss']
})
export class ItemGlDetailsComponent implements OnInit {
  public gridData: any = [];
  public mySelection: ItemGLSetupDetail[] = [];
  public selectedCallback = (args) => args.dataItem;
  public itemGLSetupDetail: ItemGLSetupDetail[] = [];

  constructor(public router: Router,
              public itemGlSetupService: ItemGlSetupService,
              public localStorage: LocalStorageIndexedService,
              public loadingIndicator: LoadingIndicatorHelper) {
  }

  async ngOnInit() {
    this.loadingIndicator.show();
    console.warn(this.localStorage.getFromSession(AppEnums.GL_CODE));
    if (this.localStorage.getFromSession(AppEnums.GL_CODE) !== null) {
      if (this.localStorage.getFromSession(AppEnums.GL_CODE) !== undefined) {
        if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
          this.itemGLSetupDetail = await this.itemGlSetupService.getItemsInGl(this.localStorage.getFromSession(AppEnums.HOME_OFFICE).hoId, this.localStorage.getFromSession(AppEnums.GL_CODE));
        } else {
          this.router.navigate([paths.itemGlSetup]).then(r => r);
        }
      } else {
        this.router.navigate([paths.itemGlSetup]).then(r => r);
      }
    } else {
      this.router.navigate([paths.itemGlSetup]).then(r => r);
    }


    this.mySelection = [];
    this.gridData = this.itemGLSetupDetail;
    this.gridData.total = this.itemGLSetupDetail.length;
    this.loadingIndicator.hide();


    // }).catch(e => {
    //   this.loadingIndicator.hide();
    //   console.log(e);
    // });

    // returns
    /*    {
          'itemDesc': "LOW VOLUME SURCHAGE',
          "itemNum": "00221",
          "itemPrice": 0,
          "itemStatus": false,
          "pckSize": 0,
          "purchaseUOM": "",
          "statusInText": "Inactive"
        },
        {
          'itemDesc': "LOW VOLUME SURCHAGE',
          "itemNum": "00221",
          "itemPrice": 0,
          "itemStatus": false,
          "pckSize": 0,
          "purchaseUOM": "",
          "statusInText": "Inactive"
        },
        */
  }

  back() {
    this.router.navigate([paths.itemGlSetup]).then(r => r);
  }
}
